import Icon from '../assets'
import { Item } from './Item'
import { extractRenderPropsChildren, RenderPropsChildren } from '../../libs/renderProps'
export interface ItemListProps {
  loading: boolean
  items: Item[]
  getMenuProps: Function
  getItemProps: Function
  highlightedIndex: number
  children: RenderPropsChildren<Item>
}

const ItemList = ({
  loading,
  items,
  getMenuProps,
  getItemProps,
  highlightedIndex,
  children
}: ItemListProps) => {
  if (loading) {
    return (
      <div class='control-dropdown'>
        <div class='control-dropdown__list'>
          <div class='loader'>
            <Icon icon='loader' />
          </div>
        </div>
      </div>
    )
  }
  if (items.length > 0) {
    return (
      <div class='control-dropdown'>
        <div {...getMenuProps({ class: 'control-dropdown__list' })}>
          {items.map((item, index) => (
            <a
              key={index}
              {...getItemProps({
                index,
                item: items[index],
                class: `selector-item ${
                  highlightedIndex === index ? 'active' : ''
                } qa-selector-item`
              })}
            >
              {extractRenderPropsChildren(children)(item)}
            </a>
          ))}
        </div>
      </div>
    )
  }
  return null
}
export default ItemList
